const hasTbdText = value => typeof value === 'string' && value.toLowerCase().includes('tbd');

export const computeSectionTbdState = (records) => {
  const tbdFields = {};
  let hasTbd = false;

  records.forEach((record) => {
    if (!record || typeof record !== "object") {
      return;
    }

    const zoneKey = record.Zone !== undefined && record.Zone !== null
      ? String(record.Zone)
      : null;

    if (zoneKey && !tbdFields[zoneKey]) {
      tbdFields[zoneKey] = {};
    }

    Object.entries(record).forEach(([fieldKey, fieldValue]) => {
      const isTbd = hasTbdText(fieldValue);

      if (zoneKey) {
        tbdFields[zoneKey][fieldKey] = (tbdFields[zoneKey][fieldKey] || false) || isTbd;
      } else {
        tbdFields[fieldKey] = (tbdFields[fieldKey] || false) || isTbd;
      }

      if (isTbd) {
        hasTbd = true;
      }
    });
  });

  return { tbdFields, hasTbd };
};
